import { toLabelValue } from '@/common/convertToDropdownOptions';
import { Spinner } from '@/components/Spinner';
import { useGetClubPlanDetail } from '../hooks/useGetClubPlanDetail';
import { useGetTimeInterval } from '../hooks/useGetTimeInterval';
import ClubPlanFormView from './ClubPlanFormView';

const ClubPlanForm = ({
  clubId,
  planId = '',
  commonClubId,
}: {
  clubId: string;
  planId?: string;
  commonClubId?: string;
}) => {
  const { clubPlanDetails, isLoading } = useGetClubPlanDetail(clubId, planId);

  const toStringOr = (val: number | undefined, fallback: string) => (val != null ? String(val) : fallback);
  const { data = [] } = useGetTimeInterval(clubId);
  const lastEntryTimeOptions = toLabelValue(data, {
    labelKey: 'timeInterval',
    valueKey: 'timeInterval',
  });

  const defaultValues = {
    lastEntryTime: clubPlanDetails?.lastEntryTime ?? 'default',
    nomination: toStringOr(clubPlanDetails?.nomination, 'default'),
    noOfPeople: toStringOr(clubPlanDetails?.noOfPeople, 'default'),
    planPrice: toStringOr(clubPlanDetails?.planPrice, ''),
    planTime: (planId ? clubPlanDetails?.planTitleJp : clubPlanDetails?.planTime) ?? '',
  };
  if (isLoading) return <Spinner />;
  return (
    <ClubPlanFormView
      clubId={clubId}
      planId={planId}
      commonClubId={commonClubId}
      defaultValues={defaultValues}
      lastEntryTimeOptions={lastEntryTimeOptions}
    />
  );
};

export default ClubPlanForm;
